/* 组价数据库 页面 相关接口 */
import http from '@/assets/plugins/axios'
import {backendUrl} from '@/assets/js/config'
import queryString from 'querystring'
let headers = {'Content-type': 'application/x-www-form-urlencoded'}
export default {
  // 1. 获取所有的专业章节及地区等信息
  getMajorAndRegion (params) {
    return http.get(`${backendUrl}/data_manage/esti/front`, params)
  },
  // 2. 获取所有的专业章节
  getMajorList (params) {
    return http.get(`${backendUrl}/data_manage/esti/chapters`, params)
  },
  // 3. 获取编制人列表
  getAuthors (params) {
    return http.get(`${backendUrl}/data_manage/esti/authors`, params)
  },
  // 4. 根据专业章节获取地区
  getRegions (params) {
    return http.get(`${backendUrl}/data_manage/esti/regions`, params)
  },
  // 获取组价数据
  getEstiItems (params){
    return http.post(`${backendUrl}/data_manage/esti/items`, params)
  },
  // 移动组价数据
  moveEstiData (params){
    return http.post(`${backendUrl}/data_manage/esti/move`, params)
  },
  // 获取清单库
  getDbidsData (params){
    return http.get(`${backendUrl}/data_manage/esti/dbids`, params)
  },
  // 删除
  delEsti (params){
    return http.delete(`${backendUrl}/data_manage/esti/delete`, params)
  },
  // 上传云文件
  uploadCloudFile (params){
    return http.post(`${backendUrl}/data_manage/bill_quantity/upload_cloud_file`, params, headers)
  },
  // 导出数据
  exportData (params){
    return http.post(`${backendUrl}/data_manage/esti/pre_export`, params)
  },
  // 修改定额
  putNormitemData (params){
    return http.put(`${backendUrl}/data_manage/esti/normitem`, params, headers)
  },
  // 修改清单
  putBqItemData (params){
    return http.put(`${backendUrl}/data_manage/esti/bqitem`, params, headers)
  },
  // 获取最近使用标签
  getUsedLabels (params){
    return http.get(`${backendUrl}/data_manage/esti/last_used_labels`, params)
  },
  // 添加、修改标签
  editLables (params){
    return http.post(`${backendUrl}/data_manage/esti/lables`, params, headers)
  },
  // 批量取消清单最佳组价
  cancelBestEsti (params){
    return http.put(`${backendUrl}/data_manage/esti/batch_cancel_best_esti`, params, headers)
  },
  // 批量设置最佳组价
  setBestEsti (params){
    return http.put(`${backendUrl}/data_manage/esti/batch_set_best_esti`, params, headers)
  },
  // 获取所有非最佳组价的组价id
  getNoBestEstiIds (params){
    return http.post(`${backendUrl}/data_manage/esti/non_best_esti_ids`, params)
  },
  // 获取已设置为最佳组件的组价id
  getBestEstiIds (params){
    return http.post(`${backendUrl}/data_manage/esti/best_esti_ids`, params)
  },
  // 修改审查状态
  putInspect (params){
    return http.put(`${backendUrl}/data_manage/esti/inspect`, params, headers)
  },

  // 6.1  批量审核 人材机数据
  inspectBatch (query, params) {
    return http.put(`${backendUrl}/data_manage/esti/inspect_batch?` + queryString.stringify(query), params)
  },

  // 加载人材机数据
  getNormsData (params){
    return http.post(`${backendUrl}/data_manage/esti/norm_resources`, params, headers)
  },
  // 修改人材机数据
  putResource (params){
    return http.put(`${backendUrl}/data_manage/esti/resource`, params, headers)
  },
  // 复制组价数据到企业空间
  estiCopy (params){
    return http.post(`${backendUrl}/data_manage/esti/copy`, params)
  }
}

